/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import { useState } from 'react';
import { getServiceability } from '../../../components/delivery/helper';

export default function GetServiceability() {
    const [deliveryPartner, setDeliveryPartner] = useState(2);
    const [sourcePincode, setSourcePincode] = useState('201301');
    const [destinationPincode, setDestinationPincode] = useState('');
    const [containsLiquid, setContainsLiquid] = useState(false);
    const [isCod, setIsCod] = useState(false);
    const [loading, setLoading] = useState(false);
    const [couriers, setCouriers] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const availability = await getServiceability(deliveryPartner, { pickup: sourcePincode, delivery: destinationPincode }, containsLiquid, isCod);
        if (availability && availability.couriers) {
            setCouriers(availability.couriers);
        }
        setLoading(false);
    }

    return (
        <div className='p-5'>
            <p className='text-left text-4xl font-semibold mb-7 '>Get Servicability</p>
            <form className='flex flex-col gap-5' onSubmit={handleSubmit}>
                <div className='flex flex-col gap-5'>
                    <div className='flex flex-col flex-auto'>
                        <label>Delivery Partner</label>
                        <select className='p-2.5 border border-gray-300 rounded-xl w-full' value={deliveryPartner} onChange={(e) => setDeliveryPartner(e.target.value)}>
                            <option value={1}>Shiprocket</option>
                            <option value={2}>DTDC</option>
                        </select>
                    </div>
                    <div className='flex flex-row flex-1 gap-3'>
                        <div className='flex flex-col flex-auto'>
                            <label>Source Pincode</label>
                            <input maxLength={6} value={sourcePincode} onChange={(e) => setSourcePincode(e.target.value)} className='p-2.5 border border-gray-300 rounded-xl ' placeholder='Source Pincode'></input>
                        </div>
                        <div className='flex flex-col flex-auto'>
                            <label>Destination Pincode</label>
                            <input maxLength={6} value={destinationPincode} onChange={(e) => setDestinationPincode(e.target.value)} className='p-2.5 border border-gray-300 rounded-xl ' placeholder='Source Pincode'></input>
                        </div>
                    </div>
                    <div className='flex flex-row flex-1 gap-3'>
                        <div className='flex gap-2 flex-auto'>
                            <label>Contains Liquid</label>
                            <input type='checkbox' className='p-2.5 border border-gray-300 rounded-xl ' checked={containsLiquid} onChange={() => setContainsLiquid(!containsLiquid)}></input>
                        </div>
                        <div className='flex gap-2 flex-auto'>
                            <label>Is COD</label>
                            <input type='checkbox' className='p-2.5 border border-gray-300 rounded-xl ' checked={isCod} onChange={() => setIsCod(!isCod)}></input>
                        </div>
                    </div>
                    {couriers.length > 0 && <hr />}
                    {
                        couriers.length > 0 && <div className='flex flex-col flex-auto'>
                            <label>Couriers</label>
                            <div className='flex flex-col flex-auto gap-2'>
                                {couriers?.map((courier) => (
                                    <div key={courier.NAME} className='flex justify-between p-2.5 border border-gray-300 rounded-xl' >
                                        <div key={courier.NAME}>{courier.NAME}</div>
                                        <div key={courier.TAT}>{`TAT: ${courier.TAT}`}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                </div>
                <button type='submit' className='p-2.5 bg-elm-500 text-[white] rounded-lg'> {loading ? 'Loading...' : 'Get Servicability'}</button>
            </form>
        </div>
    )
}
